// ##### Komarov 2025-07-02: Добавил пол в ClientTitles
// ##### Komarov 2025-07-08
export const ClientTitles = [' ', 'Mr', 'Mrs', 'Ms', 'Dr'];
export const ClientGenders = [' ', 'M', 'F'];
// ##### Komarov 2025-07-02: Добавил категории клиентов (TODO: пока в коде, потом будем получать их из Смарта)
// ##### Komarov 2025-07-08
export const ClientCategories = {
  en: ['Adult', 'Teenager (3 - 13 y.o.)', 'Baby (0 - 2 y.o.)'],
  fr: ['Adulte', 'Adolescent (3 - 13 ans)', 'Bébé (0 - 2 ans)'],
  uk: ['Дорослий', 'Підліток (3 - 13 р.)', 'Немовля (0 - 2 р.)'],
  ru: ['Взрослый', 'Подросток (3 - 13 л.)', 'Малыш (0 - 2 г.)'],
};
